export const DEFAULT_TITLE = "Revyalb";